import * as actionHelper from '@/modules/app/helpers/actions'
import Vue from 'vue'

export default {
  addForToday (store, payload) {
    const params = actionHelper.urlSearchParamsFromProperties(payload)
    return Vue.axios.post('today/inspection', params)
  }
}
